<script>
import { mapGetters } from 'vuex';
import router from '../../../../index';
import { useAlert } from 'dashboard/composables';
import { useVuelidate } from '@vuelidate/core';

import Spinner from 'dashboard/components-next/spinner/Spinner.vue';
import PageHeader from '../../SettingsSubPageHeader.vue';
import AgentSelector from '../AgentSelector.vue';

export default {
  components: {
    Spinner,
    PageHeader,
    AgentSelector,
  },
  validations: {
    selectedAgents: {
      isEmpty() {
        return !!this.selectedAgents.length;
      },
    },
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      selectedAgents: [],
      isCreating: false,
    };
  },

  computed: {
    ...mapGetters({
      agentList: 'agents/getAgents',
      uiFlags: 'branchMembers/getUIFlags',
    }),

    branchId() {
      return this.$route.params.branchId;
    },
    headerTitle() {
      return this.$t('BRANCHES_SETTINGS.AGENTS.EDIT_TITLE', {
        branchName: this.currentBranch?.name || '',
      });
    },
    currentBranch() {
      return this.$store.getters['branches/getBranch'](this.branchId);
    },
    branchMembers() {
      return this.$store.getters['branchMembers/getBranchMembers'](
        this.branchId
      );
    },
    showAgentsList() {
      const { id } = this.currentBranch;
      return id && !this.uiFlags.isFetching;
    },
  },

  async mounted() {
    const { branchId } = this.$route.params;
    this.$store.dispatch('agents/get');
    try {
      await this.$store.dispatch('branchMembers/get', {
        branchId,
      });
      const members = this.branchMembers.map(item => item.id);
      this.updateSelectedAgents(members);
    } catch {
      this.updateSelectedAgents([]);
    }
  },

  methods: {
    updateSelectedAgents(newAgentList) {
      this.v$.selectedAgents.$touch();
      this.selectedAgents = [...newAgentList];
    },
    async addAgents() {
      this.isCreating = true;
      const { branchId, selectedAgents } = this;

      try {
        await this.$store.dispatch('branchMembers/update', {
          branchId,
          agentsList: selectedAgents,
        });
        useAlert('Agentes actualizados exitosamente');
        router.push({
          name: 'settings_branches_list',
        });
        this.$store.dispatch('branches/get');
      } catch (error) {
        useAlert(error.message);
      }
      this.isCreating = false;
    },
  },
};
</script>

<template>
  <div class="h-full w-full p-8 col-span-6 overflow-auto">
    <form class="flex flex-col gap-4 mx-0" @submit.prevent="addAgents">
      <PageHeader
        :header-title="headerTitle"
        :header-content="$t('BRANCHES_SETTINGS.AGENTS.HEADER_CONTENT')"
      />

      <div class="w-full h-full">
        <div v-if="v$.selectedAgents.$error">
          <p class="error-message pb-2">
            {{ $t('BRANCHES_SETTINGS.AGENTS.VALIDATION_ERROR') }}
          </p>
        </div>
        <AgentSelector
          v-if="showAgentsList"
          :agent-list="agentList"
          :selected-agents="selectedAgents"
          :update-selected-agents="updateSelectedAgents"
          :is-working="isCreating"
          :submit-button-text="$t('BRANCHES_SETTINGS.AGENTS.UPDATE_BUTTON')"
        />
        <div v-else class="flex items-center justify-center py-6">
          <Spinner class="text-n-blue-11" />
        </div>
      </div>
    </form>
  </div>
</template>
